export enum OwnershipType {
  BOSCH = '0',
  COMMUNITY = '1',
}

export enum OwnershipName {
  BOSCH = 'Bosch',
  COMMUNITY = 'Community',
}
